module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_M2-5b49b3505686f65a998310bd1169f55b.webp";